module.exports = __webpack_public_path__ + "img/ic_position.973ace8b.svg";